import {
  includes, isEmpty, isNaN, lowerCase,
} from 'lodash';

export default {
  config: (state) => state.config,
  channel: (state) => state.channel,
  channels: (state) => state.channels,
  exportType: (state) => state.exportType,
  infoMessage: (state) => state.infoMessage,
  isLightningRoulette: (state, getters) => !isEmpty(getters.wheel) && includes(lowerCase(getters.wheel.type.name), 'lightning'),
  isKolor: (state, getters) => !isEmpty(getters.wheel) && includes(lowerCase(getters.wheel.type.name), 'kolor'),
  paginationConfig: (state) => state.paginationConfig,
  platform: (state) => state.platform,
  platformTimezoneOffset: (state) => {
    const offset = Number(state.config.timezoneOffset);
    return isNaN(offset) ? 0 : offset;
  },
  rounds: (state) => state.rounds,
  jackpots: (state) => state.jackpots,
  route: (state) => state.route,
  selectedFilters: (state) => state.selectedFilters,
  tickets: (state) => state.tickets,
  ticketBets: (state) => state.ticketBets,
  ticketFilters: (state) => state.ticketFilters,
  toolbarFilters: (state) => state.toolbarFilters,
  token: (state) => state.token,
  translation: (state) => (key) => state.translations[key],
  translations: (state) => state.translations,
  user: (state) => state.user,
  userTimezoneOffset: (state) => {
    const offset = state.user ? Number(state.user.timezoneOffset) : 0;
    return isNaN(offset) ? 0 : offset;
  },
  ui: (state) => state.ui,
  userTimezone: (state) => state.user.timezone,
  wheel: (state, getters) => getters.config.wheel,
};
